<template>
      
      <v-container fluid style="position:absolute">


    <v-card class="mx-auto" tile max-width="500">
      <v-toolbar dense flat color="primary">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn icon dark v-on="on">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>

          <form ref="eventDialogForm" @submit.prevent="save">
            <v-card>
              <v-card-title>
                <span class="headline">
                  <span v-if="currentItem.id">Edit</span>
                  <span v-else>Add</span>
                  Event
                </span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex sm12>
                      <v-text-field
                        v-if="dialog"
                        autofocus
                        v-model="currentItem.title"
                        label="Event Title"
                      ></v-text-field>
                    </v-flex>

                    <v-flex sm6>
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        persistent
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date"
                            label="Picker in dialog"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex sm6>
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        persistent
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date"
                            label="Picker in dialog"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" type="submit" text>Save</v-btn>
              </v-card-actions>
            </v-card>
          </form>
        </v-dialog>
      </v-toolbar>

      <v-list>
        <v-subheader dense>My Events</v-subheader>

        <v-list-item-group v-model="myevents">
          <v-list-item dense v-for="(item, i) in myevents" :key="item.id">
            <v-list-item-content @click="$router.push('/event/'+item.id)">
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-btn icon @click="editItem(item)">
                <v-icon color="pink">mdi-pencil</v-icon>
              </v-btn>

              <v-btn icon @click="removeItem(item.id)">
                <v-icon color="pink">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
        </v-container>
    

</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  data: () => ({
    title: "",
    currentItem: {},
    dialog: false,
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false
  }),
  methods: {
    ...mapActions("events", ["insert", "set", "delete"]),
    save() {
      let data = {
        owner: this.user.uid,
        title: this.currentItem.title
      };
      if (!this.currentItem.id) {
        this.insert({
          ...data
        });
      } else {
        this.set({
          ...data,
          id: this.currentItem.id
        });
      }
      this.currentItem = {};
      this.dialog = false;
    },
    removeItem(id) {
      this.delete(id);
    },
    editItem(item) {
      this.currentItem = { ...item, id: item.id };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.currentItem = {};
    }
  },
  computed: {
    ...mapState({
      user: state => state.application.user
    }),
    myevents: {
      get() {
        return this.$store.state.events.data;
      },
      set() {}
    }
  },

  created() {}
};
</script>
